import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import {
    ADDRESS_1,
    BRAND_SUB,
    CITY,
    EMAIL,
    EMAIL_MAILTO,
    FACEBOOK_URL,
    HOURS,
    INSTAGRAM_URL,
    NAV_LINKS,
    PHONE2_SHORT,
    PHONE2_TEL,
    PHONE_SHORT,
    PHONE_TEL,
} from "../../data/site";

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="border-t border-white/[0.07] px-5 pb-28 pt-14 md:px-10 md:pb-14"
    >
        <div className="mx-auto grid max-w-[1400px] gap-12 md:grid-cols-4">
            <div>
                <img
                    src="/logo.png"
                    alt="Ramljak Auto Centar — logo"
                    className="h-24 w-auto"
                />
                <p className="mt-3 text-[9px] font-medium tracking-[0.44em] text-silver">
                    {BRAND_SUB}
                </p>
                <div className="mt-5 flex gap-3">
                    <a
                        href={FACEBOOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-facebook"
                        aria-label="Facebook profil"
                        className="flex h-10 w-10 items-center justify-center border border-white/15 text-silver transition-colors duration-300 hover:border-bronze hover:text-bronze"
                    >
                        <Facebook size={16} strokeWidth={1.5} />
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-instagram"
                        aria-label="Instagram profil"
                        className="flex h-10 w-10 items-center justify-center border border-white/15 text-silver transition-colors duration-300 hover:border-bronze hover:text-bronze"
                    >
                        <Instagram size={16} strokeWidth={1.5} />
                    </a>
                </div>
            </div>

            <div>
                <p className="text-[10px] font-medium uppercase tracking-[0.34em] text-bronze">
                    Kontakt
                </p>
                <a
                    href={PHONE_TEL}
                    data-testid="footer-phone"
                    className="mt-4 block text-sm text-bone transition-colors hover:text-bronze"
                >
                    {PHONE_SHORT}
                </a>
                <a
                    href={PHONE2_TEL}
                    data-testid="footer-phone2"
                    className="mt-1.5 block text-sm text-bone transition-colors hover:text-bronze"
                >
                    {PHONE2_SHORT}
                </a>
                <a
                    href={EMAIL_MAILTO}
                    data-testid="footer-email"
                    className="mt-2 block text-sm text-silver transition-colors hover:text-bronze"
                >
                    {EMAIL}
                </a>
                <p className="mt-2 text-sm text-silver">
                    {ADDRESS_1}, {CITY}
                </p>
            </div>

            <div>
                <p className="text-[10px] font-medium uppercase tracking-[0.34em] text-bronze">
                    Radno vrijeme
                </p>
                <ul className="mt-4 space-y-1.5 text-sm text-silver">
                    {HOURS.map((h) => (
                        <li key={h.days}>
                            {h.days}: <span className="text-bone/80">{h.time}</span>
                        </li>
                    ))}
                </ul>
            </div>

            <div>
                <p className="text-[10px] font-medium uppercase tracking-[0.34em] text-bronze">
                    Stranice
                </p>
                <nav className="mt-4 flex flex-col gap-2.5">
                    {NAV_LINKS.map((l) => (
                        <Link
                            key={l.id}
                            to={l.to}
                            data-testid={`footer-link-${l.id}`}
                            className="text-sm text-silver transition-colors hover:text-bone"
                        >
                            {l.label}
                        </Link>
                    ))}
                    <Link
                        to="/termin"
                        data-testid="footer-link-termin"
                        className="text-sm font-medium text-bone transition-colors hover:text-bronze"
                    >
                        ZAKAŽI TERMIN
                    </Link>
                </nav>
            </div>
        </div>

        <div className="mx-auto mt-12 max-w-[1400px] border-t border-white/[0.06] pt-5">
            <p className="text-[10px] tracking-wide text-silver/60">
                © {new Date().getFullYear()} Ramljak — Auto Detailing Centar,
                Ljubuški
            </p>
        </div>
    </footer>
);
